module.exports = __webpack_public_path__ + "static/media/logZoomIn.16fda9b6.svg";